// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PageNameOrCategoryRouteImport } from './routes/$pageNameOrCategory'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as BroadcastScheduleRouteImport } from './routes/broadcastSchedule'
import { Route as EpisodesRouteImport } from './routes/episodes'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as PopoutRouteImport } from './routes/popout'
import { Route as RecordingsRouteImport } from './routes/recordings'
import { Route as ViewRouteRouteImport } from './routes/view/route'
import { Route as PageNameOrCategoryPageNameRouteImport } from './routes/$pageNameOrCategory_.$pageName'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminDirectorsRouteImport } from './routes/admin/directors'
import { Route as AdminEpisodesRouteImport } from './routes/admin/episodes'
import { Route as AdminPollsRouteImport } from './routes/admin/polls'
import { Route as AdminPupilsRouteImport } from './routes/admin/pupils'
import { Route as AdminRecordingsRouteImport } from './routes/admin/recordings'
import { Route as AdminSeasonsRouteImport } from './routes/admin/seasons'
import { Route as AdminSettingsRouteRouteImport } from './routes/admin/settings/route'
import { Route as AdminShowsRouteImport } from './routes/admin/shows'
import { Route as AdminPagesIndexRouteImport } from './routes/admin/pages.index'
import { Route as AdminPagesNameRouteImport } from './routes/admin/pages.$name'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin/settings/index'
import { Route as AdminSettingsGroupsRouteImport } from './routes/admin/settings/groups'
import { Route as AdminSettingsSiteRouteImport } from './routes/admin/settings/site'
import { Route as AdminSettingsTeamRouteImport } from './routes/admin/settings/team'
import { Route as SupervisorsResetPasswordIndexRouteImport } from './routes/supervisors/resetPassword.index'
import { Route as SupervisorsResetPasswordTokenRouteImport } from './routes/supervisors/resetPassword.$token'
import { Route as ViewEpisodesEpisodeIdRouteImport } from './routes/view/episodes/$episodeId'
import { Route as ViewPeopleContributorIdRouteImport } from './routes/view/people/$contributorId'
import { Route as ViewShowsShowIdRouteImport } from './routes/view/shows/$showId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PageNameOrCategoryRoute = PageNameOrCategoryRouteImport.update({
            id: '/$pageNameOrCategory',path: '/$pageNameOrCategory',getParentRoute: () => rootRouteImport
          })
const AdminRouteRoute = AdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const BroadcastScheduleRoute = BroadcastScheduleRouteImport.update({
            id: '/broadcastSchedule',path: '/broadcastSchedule',getParentRoute: () => rootRouteImport
          })
const EpisodesRoute = EpisodesRouteImport.update({
            id: '/episodes',path: '/episodes',getParentRoute: () => rootRouteImport
          })
const ExploreRoute = ExploreRouteImport.update({
            id: '/explore',path: '/explore',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LogoutRoute = LogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => rootRouteImport
          })
const PopoutRoute = PopoutRouteImport.update({
            id: '/popout',path: '/popout',getParentRoute: () => rootRouteImport
          })
const RecordingsRoute = RecordingsRouteImport.update({
            id: '/recordings',path: '/recordings',getParentRoute: () => rootRouteImport
          })
const ViewRouteRoute = ViewRouteRouteImport.update({
            id: '/view',path: '/view',getParentRoute: () => rootRouteImport
          })
const PageNameOrCategoryPageNameRoute = PageNameOrCategoryPageNameRouteImport.update({
            id: '/$pageNameOrCategory_/$pageName',path: '/$pageNameOrCategory/$pageName',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRouteRoute
          })
const AdminDirectorsRoute = AdminDirectorsRouteImport.update({
            id: '/directors',path: '/directors',getParentRoute: () => AdminRouteRoute
          })
const AdminEpisodesRoute = AdminEpisodesRouteImport.update({
            id: '/episodes',path: '/episodes',getParentRoute: () => AdminRouteRoute
          })
const AdminPollsRoute = AdminPollsRouteImport.update({
            id: '/polls',path: '/polls',getParentRoute: () => AdminRouteRoute
          })
const AdminPupilsRoute = AdminPupilsRouteImport.update({
            id: '/pupils',path: '/pupils',getParentRoute: () => AdminRouteRoute
          })
const AdminRecordingsRoute = AdminRecordingsRouteImport.update({
            id: '/recordings',path: '/recordings',getParentRoute: () => AdminRouteRoute
          })
const AdminSeasonsRoute = AdminSeasonsRouteImport.update({
            id: '/seasons',path: '/seasons',getParentRoute: () => AdminRouteRoute
          })
const AdminSettingsRouteRoute = AdminSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRouteRoute
          })
const AdminShowsRoute = AdminShowsRouteImport.update({
            id: '/shows',path: '/shows',getParentRoute: () => AdminRouteRoute
          })
const AdminPagesIndexRoute = AdminPagesIndexRouteImport.update({
            id: '/pages/',path: '/pages/',getParentRoute: () => AdminRouteRoute
          })
const AdminPagesNameRoute = AdminPagesNameRouteImport.update({
            id: '/pages/$name',path: '/pages/$name',getParentRoute: () => AdminRouteRoute
          })
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminSettingsRouteRoute
          })
const AdminSettingsGroupsRoute = AdminSettingsGroupsRouteImport.update({
            id: '/groups',path: '/groups',getParentRoute: () => AdminSettingsRouteRoute
          })
const AdminSettingsSiteRoute = AdminSettingsSiteRouteImport.update({
            id: '/site',path: '/site',getParentRoute: () => AdminSettingsRouteRoute
          })
const AdminSettingsTeamRoute = AdminSettingsTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AdminSettingsRouteRoute
          })
const SupervisorsResetPasswordIndexRoute = SupervisorsResetPasswordIndexRouteImport.update({
            id: '/supervisors/resetPassword/',path: '/supervisors/resetPassword/',getParentRoute: () => rootRouteImport
          })
const SupervisorsResetPasswordTokenRoute = SupervisorsResetPasswordTokenRouteImport.update({
            id: '/supervisors/resetPassword/$token',path: '/supervisors/resetPassword/$token',getParentRoute: () => rootRouteImport
          })
const ViewEpisodesEpisodeIdRoute = ViewEpisodesEpisodeIdRouteImport.update({
            id: '/episodes/$episodeId',path: '/episodes/$episodeId',getParentRoute: () => ViewRouteRoute
          })
const ViewPeopleContributorIdRoute = ViewPeopleContributorIdRouteImport.update({
            id: '/people/$contributorId',path: '/people/$contributorId',getParentRoute: () => ViewRouteRoute
          })
const ViewShowsShowIdRoute = ViewShowsShowIdRouteImport.update({
            id: '/shows/$showId',path: '/shows/$showId',getParentRoute: () => ViewRouteRoute
          })





const AdminSettingsRouteRouteChildren = {
  AdminSettingsGroupsRoute: AdminSettingsGroupsRoute,AdminSettingsSiteRoute: AdminSettingsSiteRoute,AdminSettingsTeamRoute: AdminSettingsTeamRoute,AdminSettingsIndexRoute: AdminSettingsIndexRoute
}

const AdminSettingsRouteRouteWithChildren = AdminSettingsRouteRoute._addFileChildren(AdminSettingsRouteRouteChildren)



const AdminRouteRouteChildren = {
  AdminSettingsRouteRoute: AdminSettingsRouteRouteWithChildren,AdminDirectorsRoute: AdminDirectorsRoute,AdminEpisodesRoute: AdminEpisodesRoute,AdminPollsRoute: AdminPollsRoute,AdminPupilsRoute: AdminPupilsRoute,AdminRecordingsRoute: AdminRecordingsRoute,AdminSeasonsRoute: AdminSeasonsRoute,AdminShowsRoute: AdminShowsRoute,AdminIndexRoute: AdminIndexRoute,AdminPagesNameRoute: AdminPagesNameRoute,AdminPagesIndexRoute: AdminPagesIndexRoute
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(AdminRouteRouteChildren)




const ViewRouteRouteChildren = {
  ViewEpisodesEpisodeIdRoute: ViewEpisodesEpisodeIdRoute,ViewPeopleContributorIdRoute: ViewPeopleContributorIdRoute,ViewShowsShowIdRoute: ViewShowsShowIdRoute
}

const ViewRouteRouteWithChildren = ViewRouteRoute._addFileChildren(ViewRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRouteRoute: AdminRouteRouteWithChildren,ViewRouteRoute: ViewRouteRouteWithChildren,PageNameOrCategoryRoute: PageNameOrCategoryRoute,BroadcastScheduleRoute: BroadcastScheduleRoute,EpisodesRoute: EpisodesRoute,ExploreRoute: ExploreRoute,LoginRoute: LoginRoute,LogoutRoute: LogoutRoute,PopoutRoute: PopoutRoute,RecordingsRoute: RecordingsRoute,PageNameOrCategoryPageNameRoute: PageNameOrCategoryPageNameRoute,SupervisorsResetPasswordTokenRoute: SupervisorsResetPasswordTokenRoute,SupervisorsResetPasswordIndexRoute: SupervisorsResetPasswordIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)